import React from 'react';
import { Control, FieldErrors, UseFormSetValue, UseFormTrigger } from 'react-hook-form';

// GRAPHQL
import { TitleFull as Title } from '@warehouse/title/core';

// STYLE
import { FirstTwoRowsWrapper, StepTwoWrapper } from '../style';
import { Manifestation } from './Manifestation';
import Movie from './Movie';
import Compilation from './Compilation';
import Season from './Season';
import Series from './Series';
import Episode from './Episode';
import Supplemental from './Supplemental';
import Performance from './Performance';
import useWorkTypes from '../../../../utils/hooks/titles/useWorkTypes';

interface StepTwoProps {
	control: Control<any>;
	setValue: UseFormSetValue<any>;
	errors: FieldErrors<any>;
	workType: string | undefined;
	trigger: UseFormTrigger<any>;
	dryRanTitle: Title | undefined;
}

function StepTwo({ control, errors, setValue, workType, trigger, dryRanTitle }: StepTwoProps) {
	const { getNameByUuid } = useWorkTypes();

	const props = {
		control,
		setValue,
		trigger,
		errors,
		dryRanTitle,
	};

	const fieldsByTitleType = {
		Movie: <Movie {...props} />,
		Compilation: <Compilation {...props} />,
		Season: <Season {...props} />,
		Series: <Series {...props} />,
		Episode: <Episode {...props} />,
		Supplemental: <Supplemental {...props} />,
		Edit: <Performance {...props} />,
		Manifestation: <Manifestation {...props} />,
	};

	const fieldsToDisplay = fieldsByTitleType[getNameByUuid(workType || '') as keyof typeof fieldsByTitleType] || null;

	return (
		<StepTwoWrapper>
			<FirstTwoRowsWrapper>{fieldsToDisplay}</FirstTwoRowsWrapper>
		</StepTwoWrapper>
	);
}

export default StepTwo;
